export class ContextTypeConstants {
    static readonly GLOBAL = 'Global';
    static readonly MANAGEMENTCOMPANY = 'Management Company';
    static readonly LOCATION = 'Location';
    static readonly COMMUNITY = 'Community';
}
